import Alert from "./Alert";
import CardIcon from "./CardIcon";

function Section03({ config }) {
  return (
    <div
      id="tabs-with-card-3"
      role="tabpanel"
      aria-labelledby="tabs-with-card-item-3"
    >
      <div className="bg-white rounded max-w-3xl px-4 pt-6 lg:pt-10 pb-12 sm:px-6 lg:px-8 mx-auto">
        <div className="max-w-2xl">
          <div className="space-y-5 md:space-y-8">
            {config.show_section_title && (
              <div className="max-w-2xl mx-auto mb-10 lg:mb-14">
                <h2 className="flex items-center text-2xl font-bold md:text-4xl md:leading-tight">
                  <div className="mr-4">
                    <CardIcon sizeNum="3.5" />
                  </div>
                  保険証で確認
                </h2>
              </div>
            )}

            <Alert title="現在の健康保険証は2025年5月31日で利用できなくなります">
              お早めにマイナ保険証への切り替えをおすすめします。
              <br />
              <a
                className="decoration-2 font-medium hover:underline"
                href="https://myna.go.jp/html/hokenshoriyou_top.html"
                target="myna.go.jp"
              >
                &raquo;&nbsp;申請方法はこちら
              </a>
            </Alert>

            <p>保険証にはご自分の記号・番号・枝番やご加入の組合の組合名、保険者番号が記載されています（保険証のデザインはご加入の健康保険組合によって異なります）。</p>

            <figure className="flex flex-col justify-center items-center">
              <img
                className="w-full object-cover rounded-xl"
                src={`${process.env.PUBLIC_URL}/images/legacy-card.png`}
                alt="健康保険証のサンプル"
              />
              <figcaption className="mt-3 text-sm text-center text-gray-500">
                ※発行時期により枝番の記載がない場合があります。その場合、マイナポータルでご確認いただけます。
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section03;
